// Validación client-side del alta de embrión EXTERNO (admin-embryos.md POST).
// Requeridos: semen (padre) + código + donante. Donante XOR (0021): existente
// (donor) | nueva referencia anidada (nombre + raza). El resto es opcional.
export function validateEmbryo(form) {
    const e = {};
    if (!form.semen) e.semen = 'Elegí el semen (padre).';

    const code = (form.code || '').trim();
    if (!code) e.code = 'Ingresá el código de la pajuela.';
    else if (code.length > 40) e.code = 'Máximo 40 caracteres.';

    if (form.donorMode === 'new') {
        if (!(form.donor_name || '').trim()) e.donor_name = 'Ingresá el nombre de la donante.';
        if (!form.donor_race_id) e.donor_race_id = 'Elegí la raza de la donante.';
    } else if (!form.donor) {
        e.donor = 'Elegí la donante.';
    }
    return e;
}
